import axios from '@/utils/request';

function GET_LIST(params) {
    return axios.get("/kshadmin/PanelRole/index", {
        params: params
    })
}

function CHANG_STATUS(params) {
    return axios.post("/kshadmin/PanelRole/statusEdit", {
        ...params
    })
}

function DELE(params) {
    return axios.post("/kshadmin/PanelRole/delete", {
        ids: params
    })
}

export default {
    GET_LIST,
    CHANG_STATUS,
    DELE
};